export enum operationTypeEnum {
  RVDOTP = 'RVDOTP',
  DYNSIG = 'DYNSIG',
  SIG = 'SIG',
  ACEP = 'ACEP',
  NOTE = 'NOTE',
  QERDS = 'QERDS',
  VAL = 'VAL',
  DWN = 'DWN',
  SIGBIO = 'SIGBIO',
  NOTI = 'NOTI',
  SIGORGA = 'SIGORGA',
  SIGAUT = 'SIGAUT',
  SMSCERT = 'SMSCERT',
  STOP = 'STOP',
  OTP = 'OTP',
  SIGQSCD = 'SIGQSCD'
}
